import React from "react";
import { Button, Card, Form, Input, Row } from "antd";
import { useLogin } from "../queries/login";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";

const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.login"));
  const { mutate: login } = useLogin();

  return (
    <Row justify="center" align="middle" style={{ marginTop: 40 }}>
      <Card title={t("pages.login.title")} style={{ maxWidth: 500 }}>
        <Form onFinish={login}>
          <Form.Item label={t("pages.login.email")} name="email">
            <Input
              placeholder={t("pages.login.email-placeholder") || undefined}
            />
          </Form.Item>
          <Form.Item label={t("pages.login.password")} name="password">
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t("pages.login.login")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Row>
  );
};

export default LoginPage;
